/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined, EyeOutlined, FilterOutlined } from '@ant-design/icons';
import {
    Button, Form,
    Input,
    Modal,
    Space,
    Table,
    Tabs,
    Tooltip,
    Typography,
    Upload, notification, DatePicker, Drawer, Select, Layout
} from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';

import history from '../../../services/history';
import ProjectModal from './ProjectModal';
import { AddOrUpdateCoatingRecord, DeleteCoatingRecordDetails, GeneratetrackRecordReport, GetCoatingRecordList, getFilterCategoryListFromDatabse } from '../../../redux/Trackrecord/saga';
import { authenticateCurrentUser } from '../../../services/auth';
import { Content, Footer } from 'antd/lib/layout/layout';
import CommonAGGridTable from '../../AG Grid/CommonAGGridTable';



const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
//const { TabPane } = Tabs;
//const { Column } = Table;
//const { Search } = Input;

//const { Option } = Select;
const CoatingRecordPage = () => {

    const defaultValues = {
        projectNo: '',
        contractor: '',
        client: '',
        project: '',
        system: '',
        startDate: '',
        linePipeDiameter: '',
        totalNoOfJoints: '',
        operatingTemp: '',
        factoryCoating: '',
        parentCoatingThickness: '',
        fjcDetails: '',
        coatingThickness: '',
        cwcThickness: '',
        cutbackLength: '',
        barge: '',
        country: '',
        onshoreOffshoreSpoolbase: '',
        fieldJointMaterials: {
            material1: '',
            material2: '',
            material3: ''
        },
        coatingThickness2: {
            thickness1: '',
            thickness2: '',
            thickness3: ''
        }
    };


    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isMasterModalVisible, setIsMasterModalVisible] = useState(false);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [currentPagesize, setCurrentPagesize] = useState(10);
    const [isEdit, setIsEdit] = useState(false);
    const [editRecord, seteditRecord] = useState('');
    const [projectDetailForm] = Form.useForm()
    const [searchCriteria, setSearchCriteria] = useState({});
    const [selectdTypeFilter, setSelectdFilterType] = useState({});
    const [searchFilterType, setSearchFilterType] = useState({});
    const [categoryList, setCategoryList] = useState({});
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isDeleteLoading, setIsDeleteLoading] = useState(false)
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [generateReportLoading, setGenerateReportLoading] = useState(false);
    const [projectNameCategory, setProjectNameCategory] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false)
    const [bulkUplaodModal, setBulkUplaodModal] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [disableFileUpload, setDisableFileUpload] = useState(false);
    const [filterCategoryList, setFilterCategoryList] = useState({
        'projectname': []
    });

    const [prevPageNumber, setPrevPageNumber] = useState(1);
    const [prevPagesize, setPrevPagesize] = useState(10);
    const [searchType, setSearchType] = useState({});

    const [activeKey, setActiveKey] = useState('1')
    const [activeKeyLine, setActiveKeyLine] = useState('1')

    const [columnDefs, setColumnDefs] = useState([])
    const [layoutSave, setLayoutSave] = useState(false);
    const [layoutLoad, setLayoutLoad] = useState(false);
    const [isPivotMode, setIsPivotMode] = useState(false);
    const [rowData, setRowData] = useState([])
    const [isCoatingLoading, setIsCoatingLoading] = useState(false);
    const [coatingListCount, setCoatingListCount] = useState(0);
    const [coatingListTotalCount, setCoatingListTotalCount] = useState(0);
    const [gridApi, setGridApi] = useState(null);
    const [loadingProgress, setLoadingProgress] = useState(0);

    


    const [userName, setUserName] = useState('');
    const [userGroup, setUserGroup] = useState([]);
    const [selectedTap, setSelectedTap] = useState('Welding');
    const [tapsList, setTaplist] = useState(['Welding', 'Coating', 'Competitor']);
    /** get user Access */
    useEffect(() => {
        authenticateCurrentUser()
            .then(async (data) => {
                if (data.signInUserSession.accessToken.payload["cognito:groups"]) {

                    let response = data.signInUserSession.accessToken.payload["cognito:groups"] //await getA(data.username)
                    //const userAccess = response.map(item => item?.GroupName)
                    //console.log(response)
                    const userEmail = JSON.parse(localStorage.getItem('user')).email
                    setUserName(userEmail);
                    setUserGroup(response);
                }
            })
            .catch((error) => {
                console.log('error', error);
            });
    }, [history]);
    useEffect(() => {
        if (!uploadLoading && bulkUplaodModal)
            setBulkUplaodModal(false)

    }, [uploadLoading])
    const keys = {
        startDate: 'Start Date',
        project: 'Project',
        projectNo: 'Project No.',
        contractor: 'Contractor',
        client: 'Client',
        system: 'System',
        linePipeDiameter: 'Line Pipe Diameter',
        totalNoOfJoints: 'Total No. of Joints',
        operatingTemp: 'Operating Temp',
        factoryCoating: 'Factory Coating',
        parentCoatingThickness: 'Parent Coating Thickness',
        fjcDetails: 'FJC Details',
        coatingThickness: 'Coating Thickness',
        cwcThickness: 'CWC Thickness',
        cutbackLength: 'Cutback Length',
        barge: 'Barge',
        country: 'Country',
        onshoreOffshoreSpoolbase: 'Onshore / Offshore / Spoolbase',
        fieldJointMaterials: 'Field Joint Materials',
        coatingThickness2: 'Coating Thickness'
    };
   


    const generateColumns = async () => {
        const parseJsonValue = (value) => {
            if (typeof value !== 'string') {
                return value;
            }

            try {
                return JSON.parse(value);
            } catch (error) {
                return value;
            }
        };
        const getObjectValue = (data, parentKey, childKey) => {
            const parentValue = parseJsonValue(data?.[parentKey]) || {};
            if (typeof parentValue === 'string') {
                return childKey.endsWith('1') ? parentValue : '';
            }
            return parentValue[childKey] || '';
        };
        const baseColumnOptions = {
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
                            buttons: ['reset'],
                        }
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ['reset'],
                        }
                    }
                ]
            }
        };
        const columnDefs = Object.keys(keys).reduce((columns, key) => {
            if (key === 'fieldJointMaterials') {
                columns.push({
                    headerName: keys[key],
                    headerClass: 'ag-center-header',
                    children: [
                        {
                            headerName: 'Material 1',
                            colId: 'fieldJointMaterials.material1',
                            valueGetter: (params) => getObjectValue(params.data, 'fieldJointMaterials', 'material1'),
                            headerClass: 'ag-center-header',
                            cellStyle: { textAlign: 'center' },
                            ...baseColumnOptions
                        },
                        {
                            headerName: 'Material 2',
                            colId: 'fieldJointMaterials.material2',
                            valueGetter: (params) => getObjectValue(params.data, 'fieldJointMaterials', 'material2'),
                            headerClass: 'ag-center-header',
                            cellStyle: { textAlign: 'center' },
                            ...baseColumnOptions
                        },
                        {
                            headerName: 'Material 3',
                            colId: 'fieldJointMaterials.material3',
                            valueGetter: (params) => getObjectValue(params.data, 'fieldJointMaterials', 'material3'),
                            headerClass: 'ag-center-header',
                            cellStyle: { textAlign: 'center' },
                            ...baseColumnOptions
                        }
                    ]
                });
                return columns;
            }

            if (key === 'coatingThickness2') {
                columns.push({
                    headerName: keys[key],
                    headerClass: 'ag-center-header',
                    children: [
                        {
                            headerName: 'Thickness 1',
                            colId: 'coatingThickness2.thickness1',
                            valueGetter: (params) => getObjectValue(params.data, 'coatingThickness2', 'thickness1'),
                            headerClass: 'ag-center-header',
                            cellStyle: { textAlign: 'center' },
                            ...baseColumnOptions
                        },
                        {
                            headerName: 'Thickness 2',
                            colId: 'coatingThickness2.thickness2',
                            valueGetter: (params) => getObjectValue(params.data, 'coatingThickness2', 'thickness2'),
                            headerClass: 'ag-center-header',
                            cellStyle: { textAlign: 'center' },
                            ...baseColumnOptions
                        },
                        {
                            headerName: 'Thickness 3',
                            colId: 'coatingThickness2.thickness3',
                            valueGetter: (params) => getObjectValue(params.data, 'coatingThickness2', 'thickness3'),
                            headerClass: 'ag-center-header',
                            cellStyle: { textAlign: 'center' },
                            ...baseColumnOptions
                        }
                    ]
                });
                return columns;
            }

            columns.push({
                headerName: keys[key],
                field: key,
                headerClass: 'ag-center-header',
                cellStyle: { textAlign: 'center' },
                ...baseColumnOptions
            });
            return columns;
        }, []);
         
        columnDefs.push(   {
                headerName: 'Actions',
                field: 'actions',
                headerClass: 'ag-center-header',
                cellStyle: { textAlign: 'center' },
                width: 200,
                pinned: 'right',
                cellRenderer: (params) => {
                    const record = params.data;
                    return (
                        <div className="table-row-actions">
                            <Tooltip title="Update">
                                <span className="icon-18 cursor-pointer edit-hover">
                                    <EditOutlined onClick={() => onUpdateClick(record)} />
                                </span>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <span className="icon-18 cursor-pointer edit-hover">
                                    <DeleteOutlined
                                        onClick={() => showDeleteModal(record)}
                                    />
                                </span>
                            </Tooltip>
                        </div>
                    );
                },
                filter: false
            }
        );

        setColumnDefs(columnDefs);
        return columnDefs;
    };
    useEffect(() => {
        generateColumns()

    }, []);
    const onUpdateClick = (record) => {

        if (record.yearStarted) {
            record.yearStarted = moment(record.trailDate).format('YYYY');
            //console.log(record.yearStarted)
        }
        projectDetailForm.setFieldsValue(record)
        //console.log(record)
        seteditRecord(record)
        setIsEdit(true)
        setIsModalVisible(true)
    }

    useEffect(() => {
        // var obj = {
        //     pageSize: currentPagesize,
        //     pageNumber: currentPageNumber,

        // }
        // onRecordList(obj);
    }, [])

    function hasNonEmptyTag(jsonObj) {
        for (const key in jsonObj) {
            if (jsonObj.hasOwnProperty(key)) {
                const value = jsonObj[key];


                if (Array.isArray(value) && value.length > 0) {
                    return true;
                } else if (typeof value === 'string' && value.trim() !== '') {
                    return true;
                }
            }
        }
        return false;
    }
   

    useEffect(() => {
        onfetchList();
    }, [])

    const onfetchList = async () => {
        var obj = {
            pageSize: 100000,
            pageNumber: currentPageNumber,
            searchKey: searchCriteria

        }
        setIsCoatingLoading(true);
        const coatingRecords = await GetCoatingRecordList(obj);
        setRowData(coatingRecords);
        setCoatingListCount(coatingRecords.length > 0 ? coatingRecords[0].totalCount : 0);
        setCoatingListTotalCount(coatingRecords.length > 0 ? coatingRecords[0].totalListCount : 0);
        setIsCoatingLoading(false);
    }
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setIsEdit(false)
    };

    const showMasterModal = () => {
        setIsMasterModalVisible(true);
    };

    const GenerateReport = async () => {
        setGenerateReportLoading(true)

        let obj = {

            searchKey: searchCriteria
        };
        //console.log(obj);


        const response = await GeneratetrackRecordReport(obj)
        if (response) {

            const link = document.createElement('a');
            link.href = response.PDFFileLink;
            link.download = 'report.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setGenerateReportLoading(false)
        }
    };


    const handleMasterCancel = () => {
        isMasterModalVisible(false);
    };
    /** Display Confirmation while deleting */
    const showDeleteModal = (record) => {
        setIsDeleteModalVisible(true);
        setSelectedData(record)
    };
    /** Deleting Spare parts data on confirm */
    const handleDeleteOk = async () => {
        // console.log(selectedData)
        setIsDeleteLoading(true)
        await DeleteCoatingRecordDetails(selectedData)
        setIsDeleteLoading(false)
        setIsDeleteModalVisible(false);
        setSelectedData('');

        setIsDeleteLoading(false)
        await onfetchList();

    }
    /** Cancelling the deletion of spare parts data */
    const handleDeleteCancel = () => {
        setIsDeleteModalVisible(false);
        setSelectedData('');
    }










    const handleDownloadFilterTable = async () => {
        setExportLoading(true);
        try {
            await createExcelTemplate();
        } finally {
            setExportLoading(false);
        }
    };
    const createExcelTemplate = async () => {
        const databaseList = Array.isArray(rowData) ? rowData : [];

        if (!databaseList.length) {
            notification.warn({ message: 'No coating records available to export.' });
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const masterstationSheet = workbook.addWorksheet('Coating Record');
            const headerRow = masterstationSheet.getRow(1);
            const childHeaderRow = masterstationSheet.getRow(2);
            headerRow.height = 20;
            childHeaderRow.height = 20;

            // const keys = [
            //     'ID',
            //     'project',
            //     "projectName",
            //     "contractor",
            //     "owningCo",
            //     "location",
            //     "yearStarted",
            //     "material",
            //     "lengthKM",
            //     "lengthMiles",
            //     "numberOfWelds",
            //     "diameter",
            //     "wt1",
            //     "wt2",
            //     "wt3",
            //     "wt4",
            //     "rentalContract",
            //     "serviceContract",
            //     "saleContract",
            //     "type",
            //     "position",
            //     "numberOfSpreads",
            //     "workmanship",
            //     "eca",
            //     "craMaterials",
            //     "specification",
            //     "numberOfStations",
            //     "rootBeadType",
            //     "externalEquip",
            //     "weldingProcess",
            //     "powerSupply",
            //     "weldingWireDiameter",
            //     "weldingWireType",
            //     "terrain",
            //     "climate",
            //     "prodRate",
            //     "repairRate",
            //     "numberOfRepairs",
            //     "inspectionType",
            //     "inspectionCompany",
            //     "comments"
            // ];

            const parseJsonValue = (value) => {
                if (typeof value !== 'string') {
                    return value;
                }

                try {
                    return JSON.parse(value);
                } catch (error) {
                    return value;
                }
            };
            const getObjectValue = (row, parentKey, childKey) => {
                const parentValue = parseJsonValue(row?.[parentKey]) || {};
                if (typeof parentValue === 'string') {
                    return childKey.endsWith('1') ? parentValue : '';
                }
                return parentValue[childKey] || '';
            };
            const exportColumns = Object.keys(keys).reduce((columns, key) => {
                if (key === 'fieldJointMaterials') {
                    columns.push(
                        { parentHeader: keys[key], header: 'Material 1', key: 'fieldJointMaterial1', width: 20 },
                        { parentHeader: keys[key], header: 'Material 2', key: 'fieldJointMaterial2', width: 20 },
                        { parentHeader: keys[key], header: 'Material 3', key: 'fieldJointMaterial3', width: 20 }
                    );
                    return columns;
                }

                if (key === 'coatingThickness2') {
                    columns.push(
                        { parentHeader: keys[key], header: 'Thickness 1', key: 'coatingThickness2Thickness1', width: 20 },
                        { parentHeader: keys[key], header: 'Thickness 2', key: 'coatingThickness2Thickness2', width: 20 },
                        { parentHeader: keys[key], header: 'Thickness 3', key: 'coatingThickness2Thickness3', width: 20 }
                    );
                    return columns;
                }

                columns.push({ parentHeader: keys[key], header: keys[key], key, width: 20 });
                return columns;
            }, []);
            const exportRows = databaseList.map(row => ({
                ...row,
                fieldJointMaterial1: getObjectValue(row, 'fieldJointMaterials', 'material1'),
                fieldJointMaterial2: getObjectValue(row, 'fieldJointMaterials', 'material2'),
                fieldJointMaterial3: getObjectValue(row, 'fieldJointMaterials', 'material3'),
                coatingThickness2Thickness1: getObjectValue(row, 'coatingThickness2', 'thickness1'),
                coatingThickness2Thickness2: getObjectValue(row, 'coatingThickness2', 'thickness2'),
                coatingThickness2Thickness3: getObjectValue(row, 'coatingThickness2', 'thickness3')
            }));

            masterstationSheet.columns = exportColumns.map(column => ({
                key: column.key,
                width: column.width
            }));
            exportColumns.forEach((column, index) => {
                const cellIndex = index + 1;
                headerRow.getCell(cellIndex).value = column.parentHeader;
                childHeaderRow.getCell(cellIndex).value = column.header;
            });

            let mergeStartIndex = 1;
            while (mergeStartIndex <= exportColumns.length) {
                const parentHeader = exportColumns[mergeStartIndex - 1].parentHeader;
                let mergeEndIndex = mergeStartIndex;
                while (mergeEndIndex < exportColumns.length && exportColumns[mergeEndIndex].parentHeader === parentHeader) {
                    mergeEndIndex += 1;
                }

                if (mergeEndIndex > mergeStartIndex) {
                    masterstationSheet.mergeCells(1, mergeStartIndex, 1, mergeEndIndex);
                } else {
                    masterstationSheet.mergeCells(1, mergeStartIndex, 2, mergeStartIndex);
                }

                mergeStartIndex = mergeEndIndex + 1;
            }

            headerRow.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            childHeaderRow.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

        masterstationSheet.addRows(exportRows);

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Coating_Record_List.xlsx';
        link.click();
        URL.revokeObjectURL(url);
    };

    const fileProps = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
            setDisableFileUpload(false);
        },
        beforeUpload: (file) => {

            setFileList([file]);
            setDisableFileUpload(true);
            return false;
        },
        fileList,
    };
    const showBulkUploadModal = () => {

        setBulkUplaodModal(true);
    }
    const handleCancelUploadFile = () => {
        setBulkUplaodModal(false);
    }
    const handleUploadFile3 = async () => {
        if (fileList.length > 0) {
            const file = fileList[0];

            if (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                const reader = new FileReader();

                reader.onload = async (event) => {
                    try {
                        const data = new Uint8Array(event.target.result);

                        const workbook = XLSX.read(data, { type: 'array' });

                        const combinedData = [];
                        const headersSet = new Set();

                        for (let index = 0; index < workbook.SheetNames.length; index++) {
                            const sheetName = workbook.SheetNames[index];
                            const sheet = workbook.Sheets[sheetName];
                            console.log('Parcing', sheetName)
                            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                            if (jsonData.length === 0 || jsonData[0].length === 0) {
                                notification.error({ message: `Sheet '${sheetName}' is empty or invalid.` });
                                continue;
                            }

                            const headers = jsonData[0];
                            // headers.forEach(header => headersSet.add(header.toLowerCase().replace(/ /g, '_')));

                            // Create a mapping of headers to keys with spaces and slashes replaced by underscores
                            const keyMapping = headers.reduce((acc, header) => {
                                let key = header
                                    .toLowerCase()
                                    .replace(/ /g, '_') // Replace spaces with underscores
                                    .replace(/\//g, '_'); // Replace slashes with underscores

                                // Remove leading underscore if added due to space at the start
                                if (key.startsWith('_')) {
                                    key = key.substring(1);
                                }

                                acc[header] = key;
                                headersSet.add(key);
                                return acc;
                            }, {});

                            const formattedData = jsonData.slice(1).map(row => {
                                const rowData = {};
                                headers.forEach((header, index) => {
                                    const mappedKey = keyMapping[header];
                                    const value = row[index];
                                    if (mappedKey !== undefined) {
                                        rowData[mappedKey] = value !== undefined ? value.toString() : ''; // Set value to empty string if undefined
                                    }
                                });
                                rowData['type'] = sheetName;
                                return rowData;
                            });

                            console.log('formattedData', formattedData)
                            combinedData.push(...formattedData);
                        }

                        // Create a new workbook with combined data
                        const combinedHeaders = Array.from(headersSet);
                        const combinedSheetData = [combinedHeaders].concat(combinedData.map(row => {
                            return combinedHeaders.reduce((acc, header) => {
                                acc[header] = row[header] || ''; // Use empty string if value is undefined
                                return acc;
                            }, {});
                        }));

                        console.log(combinedSheetData)
                        // const newWorkbook = XLSX.utils.book_new();
                        // const newSheet = XLSX.utils.aoa_to_sheet(combinedSheetData);
                        // XLSX.utils.book_append_sheet(newWorkbook, newSheet, 'CombinedData');

                        // // Write the new workbook to a file (this will trigger a download)
                        // XLSX.writeFile(newWorkbook, 'CombinedData.xlsx');

                    } catch (error) {
                        notification.error({ message: 'Error parsing Excel file. Please select a valid file.' });
                    }
                };

                reader.readAsArrayBuffer(file);

            } else {
                notification.warn({ message: 'Please select a valid Excel file (XLS or XLSX) to upload.' });
            }
        } else {
            notification.warn({ message: 'Please select a file to upload.' });
        }
    };

    const handleUploadFile1 = async () => {
        if (fileList.length > 0) {
            const file = fileList[0];

            if (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                const reader = new FileReader();

                reader.onload = async (event) => {
                    try {
                        const data = new Uint8Array(event.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });

                        const sheetName = workbook.SheetNames[0];
                        const sheet = workbook.Sheets[sheetName];

                        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                        if (jsonData[1].length === 0) {
                            notification.error({ message: 'Invalid file. Please select a valid file.' });
                            return;
                            //throw new Error('Invalid file. Please select a valid file.');
                        }
                        //console.log(jsonData)
                        //const headers = jsonData[0];
                        const masterstationSheet = {
                            columns: Object.keys(keys).map(key => ({
                                header: keys[key],
                                key: key,
                                width: 20 // Set default width, adjust as necessary
                            }))
                        };

                        // Inverse transformation to create a mapping of headers to keys
                        const keyMapping = masterstationSheet.columns.reduce((acc, column) => {
                            acc[column.header] = column.key;
                            return acc;
                        }, {});

                        const headers = jsonData[0];

                        const allHeadersAvailable = Object.keys(keyMapping)
                            .filter(key => key !== 'ID') // Exclude 'ID' key
                            .every(header => headers.includes(header));
                        console.log(allHeadersAvailable);

                        if (!allHeadersAvailable) {
                            notification.error({ message: 'Invalid header file. Please select a valid file.' });
                            return;
                            //throw new Error('Invalid file. Please select a valid file.');
                        }
                        setUploadLoading(true)
                        const toTitleCaseCountry = str => {
                            return str.toLowerCase().split(' ').map(word => {
                                if (word.includes('.')) {
                                    // Handle abbreviations like U.A.E.
                                    return word.toUpperCase();
                                } else if (word.includes('&')) {
                                    // Handle compound words like "TURKS & CAICOS ISLANDS"
                                    return word;
                                } else {
                                    return word.charAt(0).toUpperCase() + word.slice(1);
                                }
                            }).join(' ');
                        };

                        const toTitleCaseContract = (text) => {
                            return text.split(' ').map(word => {
                                // Preserve casing for words with special characters or digits
                                if (/\d/.test(word) || /[&/-]/.test(word)) {
                                    return word;
                                }
                                // Otherwise, capitalize the first letter and lowercase the rest
                                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                            }).join(' ');
                        };
                        const formattedData = jsonData.slice(1).map(row => {
                            const rowData = {};
                            let results = {}
                            headers.forEach((header, index) => {
                                const mappedKey = keyMapping[header]
                                let value = row[index];
                                // if (value !== undefined && value != '')
                                //     value = value.trim()


                                if (mappedKey !== undefined) {
                                    if (header == 'Contractor' && value !== undefined && value != '')
                                        rowData[mappedKey] = toTitleCaseContract(value)
                                    else if (header === 'Location' && value !== undefined && value != '')
                                        rowData[mappedKey] = toTitleCaseCountry(value)
                                    else if (header === 'Rental Contract' && value !== undefined && value != '')
                                        rowData[mappedKey] = toTitleCaseCountry(value)
                                    else if (header === 'Service Contract' && value !== undefined && value != '')
                                        rowData[mappedKey] = toTitleCaseCountry(value)
                                    else if (header === 'Sale Contract' && value !== undefined && value != '') {
                                        rowData[mappedKey] = toTitleCaseCountry(value)
                                    }
                                    else
                                        rowData[mappedKey] = value !== undefined ? value.toString() : ''; // Set value to empty string if undefined
                                }

                            });
                            return rowData;
                        });
                        formattedData.reverse();
                        console.log(formattedData)
                        //setConfirmLoading(true)
                        await AddOrUpdateCoatingRecord(formattedData, true)
                        await onfetchList();

                        //setTimeout(UpdateUplaodmastrList, 1000)


                    } catch (error) {
                        notification.error({ message: 'Error parsing Excel file. Please select a valid file.' });
                    }
                };

                reader.readAsArrayBuffer(file);
                setUploadLoading(false)
                setBulkUplaodModal(false);
            } else {
                notification.warn({ message: 'Please select a valid Excel file (XLS or XLSX) to upload.' });
            }
        } else {
            notification.warn({ message: 'Please select a file to upload.' });
        }
    };
    const handleUploadFile = async () => {
        if (fileList.length > 0) {
            const file = fileList[0];

            if (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                const reader = new FileReader();

                reader.onload = async (event) => {
                    try {
                        const data = new Uint8Array(event.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const sheetName = workbook.SheetNames[0];
                        const sheet = workbook.Sheets[sheetName];

                        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
                        if (jsonData.length < 2 || jsonData[1].length === 0) {
                            notification.error({ message: 'Invalid file. Please select a valid file.' });
                            return;
                        }

                        const normalizeHeader = (value) => value ? value.toString().trim().toLowerCase().replace(/[^a-z0-9]/g, '') : '';
                        const addHeaderAlias = (aliases, label, fields) => {
                            aliases[normalizeHeader(label)] = fields;
                            return aliases;
                        };
                        const headerAliases = Object.entries(keys).reduce((acc, [field, label]) => {
                            if (field !== 'fieldJointMaterials' && field !== 'coatingThickness2') {
                                const normalizedLabel = normalizeHeader(label);
                                acc[normalizedLabel] = acc[normalizedLabel] || [];
                                acc[normalizedLabel].push(field);
                            }
                            return acc;
                        }, {});
                        addHeaderAlias(headerAliases, 'Field Joint Materials', [
                            'fieldJointMaterials.material1',
                            'fieldJointMaterials.material2',
                            'fieldJointMaterials.material3'
                        ]);
                        addHeaderAlias(headerAliases, 'Material 1', ['fieldJointMaterials.material1']);
                        addHeaderAlias(headerAliases, 'Material 2', ['fieldJointMaterials.material2']);
                        addHeaderAlias(headerAliases, 'Material 3', ['fieldJointMaterials.material3']);
                        addHeaderAlias(headerAliases, 'Coating Thickness', [
                            'coatingThickness',
                            'coatingThickness2.thickness1',
                            'coatingThickness2.thickness2',
                            'coatingThickness2.thickness3'
                        ]);
                        addHeaderAlias(headerAliases, 'Thickness 1', ['coatingThickness2.thickness1']);
                        addHeaderAlias(headerAliases, 'Thickness 2', ['coatingThickness2.thickness2']);
                        addHeaderAlias(headerAliases, 'Thickness 3', ['coatingThickness2.thickness3']);
                        const headers = jsonData[0];
                        const groupedHeaderFields = {
                            fieldjointmaterials: [
                                'fieldJointMaterials.material1',
                                'fieldJointMaterials.material2',
                                'fieldJointMaterials.material3'
                            ],
                            coatingthickness: [
                                'coatingThickness2.thickness1',
                                'coatingThickness2.thickness2',
                                'coatingThickness2.thickness3'
                            ]
                        };
                        const childHeaderAliases = {
                            material1: 'fieldJointMaterials.material1',
                            material2: 'fieldJointMaterials.material2',
                            material3: 'fieldJointMaterials.material3',
                            thickness1: 'coatingThickness2.thickness1',
                            thickness2: 'coatingThickness2.thickness2',
                            thickness3: 'coatingThickness2.thickness3'
                        };
                        const childHeaderRow = jsonData[1] || [];
                        const hasExportedChildHeaderRow = childHeaderRow.some(header => childHeaderAliases[normalizeHeader(header)]);
                        const mergedHeaderMap = {};
                        (sheet['!merges'] || []).forEach(merge => {
                            if (merge.s.r !== 0 || merge.e.c <= merge.s.c) {
                                return;
                            }

                            const mergedHeader = normalizeHeader(headers[merge.s.c]);
                            const groupedFields = groupedHeaderFields[mergedHeader];
                            if (!groupedFields) {
                                return;
                            }

                            for (let columnIndex = merge.s.c; columnIndex <= merge.e.c; columnIndex += 1) {
                                mergedHeaderMap[columnIndex] = groupedFields[columnIndex - merge.s.c];
                            }
                        });
                        const inferredBlankHeaderMap = {};
                        headers.forEach((header, index) => {
                            const normalizedHeader = normalizeHeader(header);
                            const groupedFields = groupedHeaderFields[normalizedHeader];
                            if (!groupedFields) {
                                return;
                            }

                            for (let offset = 1; offset < groupedFields.length; offset += 1) {
                                const nextHeader = headers[index + offset];
                                if (nextHeader !== undefined && nextHeader !== '') {
                                    break;
                                }
                                inferredBlankHeaderMap[index + offset] = groupedFields[offset];
                            }
                        });
                        const headerMatchCounts = {};
                        const mappedHeaders = headers.map((header, index) => {
                            if (hasExportedChildHeaderRow) {
                                const childMappedField = childHeaderAliases[normalizeHeader(childHeaderRow[index])];
                                if (childMappedField) {
                                    return childMappedField;
                                }
                            }

                            if (mergedHeaderMap[index]) {
                                return mergedHeaderMap[index];
                            }

                            if (inferredBlankHeaderMap[index]) {
                                return inferredBlankHeaderMap[index];
                            }

                            const normalizedHeader = normalizeHeader(header);
                            const matchedFields = headerAliases[normalizedHeader] || [];
                            if (matchedFields.length === 0) {
                                return undefined;
                            }

                            const matchedIndex = headerMatchCounts[normalizedHeader] || 0;
                            headerMatchCounts[normalizedHeader] = matchedIndex + 1;
                            return matchedFields[Math.min(matchedIndex, matchedFields.length - 1)];
                        });
                        const matchedHeadersCount = mappedHeaders.filter(Boolean).length;
                        const dataStartIndex = hasExportedChildHeaderRow ? 2 : 1;

                        if (matchedHeadersCount === 0) {
                            notification.error({
                                message: 'Invalid header file. Please select a valid coating record Excel file.'
                            });
                            return;
                        }

                        const formattedData = jsonData.slice(dataStartIndex).map(row => {
                            const rowData = JSON.parse(JSON.stringify(defaultValues));
                            const setRowValue = (target, path, value) => {
                                const pathParts = path.split('.');
                                if (pathParts.length === 1) {
                                    target[path] = value;
                                    return;
                                }

                                const [parentKey, childKey] = pathParts;
                                target[parentKey] = target[parentKey] || {};
                                target[parentKey][childKey] = value;
                            };
                            mappedHeaders.forEach((mappedKey, index) => {
                                if (mappedKey) {
                                    const value = row[index];
                                    setRowValue(rowData, mappedKey, value !== undefined && value !== null ? value.toString() : '');
                                }
                            });
                            rowData.created_by = userName ?? '';
                            return rowData;
                        }).filter(row => Object.keys(defaultValues).some(key => {
                            const value = row[key];
                            if (value && typeof value === 'object') {
                                return Object.values(value).some(item => item !== '');
                            }
                            return value !== '';
                        }));

                        if (formattedData.length === 0) {
                            notification.error({ message: 'No valid coating record rows found in the selected file.' });
                            return;
                        }

                        formattedData.reverse();
                        setUploadLoading(true)
                        await AddOrUpdateCoatingRecord(formattedData, true)
                        await onfetchList();
                        setUploadLoading(false)
                    } catch (error) {
                        setUploadLoading(false)
                        notification.error({ message: 'Error parsing Excel file. Please select a valid file.' });
                    }
                };

                reader.readAsArrayBuffer(file);

                //  setBulkUplaodModal(false);
            } else {
                notification.warn({ message: 'Please select a valid Excel file (XLS or XLSX) to upload.' });
            }
        } else {
            notification.warn({ message: 'Please select a file to upload.' });
        }
    };
    const handleTabChange = (key) => {

        setActiveKeyLine(key);
        setSelectedTap(tapsList[Number(key) - 1])

    };

    const getWeldingDetails = () => {

        return (
            <>
                <div className="flex-auto">
                    {!isMasterModalVisible &&
                        <div className="flex-auto">
                            <div className="d-flex mb-3 align-items-center tab-content-title">


                                {/* <div className='back_equip' >
                                    <Tooltip title={'Back'} >
                                        <ArrowLeftOutlined onClick={(e) => {
                                            history.push('/SmartLync-HomePage');
                                        }} />
                                    </Tooltip>
                                </div>

                                <Title className="mb-0 add-new-calibration" level={3} style={{ paddingLeft: '30px' }}>
                                    Track Record
                                </Title> */}

                                <div className="new-calibration">

                                    <Text className="ps-3 add-new-calibration" style={{ marginTop: '10px', marginRight: '20px' }}>Filters Count: {coatingListCount} / {coatingListTotalCount}</Text>
                                    {/* <Text onClick={() => onMasterSparepartsVisibe()} className="ps-3 add-new-calibration" style={{}}>
                                    <span className="icon-22" style={{ scale: '20px' }}>
                                        <svg>
                                            <use xlinkHref="#add" />
                                        </svg>
                                    </span>
                                   Go to Database
                                </Text> */}
                                    <Text onClick={() => showModal()} className="ps-3 add-new-calibration" style={{ marginRight: '20px' }}>
                                        <span className="icon-22" style={{ scale: '20px' }}>
                                            <svg>
                                                <use xlinkHref="#add" />
                                            </svg>
                                        </span>
                                        Add New Record
                                    </Text>

                                   
                                    {
                                        userGroup && userGroup.includes('track-record-admin') &&
                                        <Button shape="round" key="apply" type="primary" style={{ marginRight: '20px' }}
                                            onClick={handleDownloadFilterTable} loading={exportLoading}
                                        >
                                            Export to Excel
                                        </Button>
                                    }
                                    {
                                        userGroup && userGroup.includes('track-record-admin') &&
                                        <Button shape="round" key="apply" type="primary" style={{ marginRight: '20px' }}
                                            onClick={showBulkUploadModal}
                                        >
                                            <CloudUploadOutlined style={{ fontSize: '20px' }}> </CloudUploadOutlined>
                                            Bulk Upload
                                        </Button>
                                    }
                                </div>


                            </div>

                            <div className='addTeamDetails'>
                               
                                <CommonAGGridTable
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    activeKeyLine="example-grid"
                                    isRawListLoading={rowData.length === 0 || isCoatingLoading}
                                    loadingMessage="Loading Coating Record..."
                                //onSelectionChanged={handleSelectionChanged}

                                />
                            </div>
                            {isModalVisible &&
                                <ProjectModal
                                    isModalVisible={isModalVisible}
                                    setIsModalVisible={setIsModalVisible}
                                    onClose={handleCancel}
                                    projectDetailForm={projectDetailForm}
                                    isEdit={isEdit}
                                    setIsEdit={setIsEdit}
                                    editRecord={editRecord}
                                    onfetchList={onfetchList}
                                    userName={userName}
                                />
                            }

                        </div>
                    }


                    <Modal
                        width="45vw"
                        className="pipeline-modal"
                        title="Delete Master  Details"
                        centered
                        visible={isDeleteModalVisible}
                        footer={[
                            <Button key="cancel" onClick={handleDeleteCancel}>
                                Cancel
                            </Button>,
                            <Button key="apply" type="primary" onClick={handleDeleteOk} loading={isDeleteLoading}>
                                {isDeleteLoading ? 'Deleting' : 'Delete'}
                            </Button>
                        ]}
                    >
                        <div>
                            <Text style={{ fontSize: '16px' }}>
                                <p>Deleting track record Details will delete all the corresponding and related information.</p>
                                Are you sure you want to delete <b style={{ color: "#EF314C" }}>{selectedData && selectedData.project}</b> coating record?</Text>
                        </div>
                    </Modal>

                    <Modal
                        className="pipeline-modal"
                        title='Upload Track Record'
                        centered
                        visible={bulkUplaodModal}
                        footer={[
                            <Button key="cancel" onClick={handleCancelUploadFile}>
                                {'Cancel'}
                            </Button>,
                            <Button key="apply" type="primary" onClick={handleUploadFile} loading={uploadLoading}>
                                {'Upload'}
                            </Button>
                        ]}
                    >
                        <div className='uploadFile_admin'>
                            <Upload {...fileProps} maxCount={1} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
                                <Button disabled={disableFileUpload} icon={<CloudUploadOutlined className='icon-22' />}>Select File</Button>
                            </Upload>
                        </div>
                    </Modal>
                </div>

            </>

        )
    }

    

    return (

        <div className="d-flex flex-column h-100">
            {!isMasterModalVisible && <div>
            
                {getWeldingDetails()}
            </div>
            }

          
        </div>
    );
};
export default CoatingRecordPage;

